// extracted by mini-css-extract-plugin
export var heroImage = "_d3-1";
export var modal = "_d3-0";